export default __webpack_public_path__ + "static/media/wiare.4dab40c0.svg";